import { Reveal } from "@/components/site/Reveal";
import { ArrowUpRight } from "@phosphor-icons/react";

const articles = [
  {
    tag: "Preventive Health",
    title: "Understanding Pharmacology in Everyday Medicine",
    excerpt: "A general overview of what pharmacology is and how the safe, informed use of medicines supports patient care.",
    author: "Dr. Sangeeta Roy",
    date: "Sample · Draft",
    img: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    tag: "Healthy Lifestyle",
    title: "Everyday Habits that Support Long-Term Well-being",
    excerpt: "General, non-personalised information on lifestyle habits that can support overall health.",
    author: "Dr. Sangeeta Roy",
    date: "Sample · Draft",
    img: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    tag: "When to Consult",
    title: "Knowing When to See a Physician",
    excerpt: "General guidance on situations where consulting a physician is advisable. Not a substitute for medical advice.",
    author: "Dr. Sangeeta Roy",
    date: "Sample · Draft",
    img: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export function HealthEducation() {
  return (
    <section className="py-24 md:py-32 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-xl">
            <span className="label">Health & Patient Education</span>
            <h2 className="font-display text-4xl sm:text-5xl tracking-tight leading-tight mt-4 text-[#0A192F]">
              Health & Patient Education
            </h2>
          </div>
          <p className="text-sm text-[#64748B] font-mono max-w-xs italic">Sample articles. Full article management can be enabled later.</p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8" data-testid="health-education-grid">
          {articles.map((a, i) => (
            <Reveal key={a.title} delay={i * 0.1}>
              <article className="group cursor-pointer">
                <div className="overflow-hidden rounded-2xl aspect-[4/3] bg-[#F4F7FA]">
                  <img src={a.img} alt={a.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)]" />
                </div>
                <span className="label text-[0.55rem] mt-5 block">{a.tag}</span>
                <h3 className="font-display text-2xl mt-2 text-[#0A192F] leading-snug">{a.title}</h3>
                <p className="mt-2 text-[#475569] leading-relaxed">{a.excerpt}</p>
                <div className="mt-4 flex items-center justify-between text-xs font-mono text-[#64748B]">
                  <span>{a.author} · {a.date}</span>
                  <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </div>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <p className="mt-8 text-xs text-[#64748B] italic max-w-3xl">
            Medical disclaimer: Educational content is general in nature and not a substitute for personalised medical advice, diagnosis or treatment. Each article will include an author, publication date, updated date and disclaimer.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
